import { render, staticRenderFns } from "./asset-location.vue?vue&type=template&id=183d75c0&"
import script from "./asset-location.vue?vue&type=script&lang=js&"
export * from "./asset-location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports